import Model from "./Model";

export default class CorrectionScore extends Model {
  id: number;
  correctionCriteriaId: number
  annotationIds: number[];
  score: number;
  maxScore: number;
  correctionId: number;

  constructor(correctionScore: any, getters: any) {
    super(getters);
    this.id = correctionScore.id;
    this.score = correctionScore.score;
    this.correctionCriteriaId = correctionScore.correctionCriteriaByCorrectionCriteriaId || correctionScore.correctionCriteriaId;
    this.annotationIds = correctionScore.annotationsByCorrectionScoreId;
    this.correctionId = correctionScore.correctionId;
  }
  correctionCriteria() {
    return this.getters.correctionCriteriaById(this.correctionCriteriaId)
  }
  knowledge() {
    if (this.correctionCriteriaId) {
      return this.correctionCriteria().knowledge()
    } else {
      return {}
    }
  }
  annotations() {
    // todo: order by coordinates
    return this.annotationIds.map((annotationId: number) =>
      this.getters.annotationById(annotationId)
    );
  }
}